// extracted by mini-css-extract-plugin
export default {"container":"src_container__BKuaW"};